import React from 'react';
import dateFormat from 'dateformat';
import classNames from 'classnames';
import { isEmpty, isNil, get, isString, join, startCase, kebabCase, replace } from 'lodash';
import DefaultAvatar from '../../assets/images/avatar.svg';
import ASQ_SE2Logo from '../../assets/images/asq_se2-logo.svg';
import ASQ_3Logo from '../../assets/images/asq_3-logo.svg';
import moment from 'moment-timezone';

export const STICKY_HEIGHT = 90;

export const formatDate = d => isEmpty(d) ? '' : dateFormat(new Date(d), 'mm/dd/yyyy');
export const formatDateTime = d => dateFormat(new Date(d), 'mm/dd/yyyy hh:MM tt');
export const formatDateTimeDay = d => dateFormat(new Date(d), 'ddd m/d/yyyy hh:MM tt');
export const formatAssignedDate = d => dateFormat(new Date(d), 'mmm. d, yyyy');
export const formatChartDate = d => moment.utc(d).format('MMM, DD'); //dateFormat(Date.parse(d), 'mmm, dd');
export const formatChatDate = d => dateFormat(new Date(d), 'mmm d HH:MM');

export const formatMapNames = a => join(a.map(v => v.label), ', ');
export const formatMapIds = a => join(a.map(v => v.value), ',')

export const columnName = c => c.replace(/\s([^\s]*)$/,'\n$1');

export const avatarUrl = (player) => `url('${get(player, 'avatarUrl') || DefaultAvatar}')`;

export const ASQLogos = {
  asq_se2: ASQ_SE2Logo,
  asq_3: ASQ_3Logo,
};

export const formatStatsValue = (value) => {
  return isString(value) ? value : Math.round(value)
}

export const getTimeZone = () => moment.tz.guess()
export const textWithBreak = t => !isEmpty(t) && `${t}\n`

export const getSectionColor = (name) => replace(kebabCase(name), '*', '')

const AsqSectionAbbr = {
  'Communication': 'COMM ',
  'Gross Motor': 'GM ',
  'Fine Motor': 'FM ' ,
  'Problem-Solving': 'PROB ',
  'Personal-Social': 'PERS ',
};

export const getSectionAbbr = (name) => AsqSectionAbbr[name]

export const transformFeedback = (data) => join(data.map(f => startCase(f)), ', ');
